import type { Session } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

export function isAdminEmail(email: string | null | undefined) {
  return email?.toLowerCase().endsWith("@welivdit.com") ?? false;
}

export async function hasAdminAccess(session: Session) {
  // Authoritative check: only the DB `user_roles` table grants admin access.
  // Email domain is NOT used as an authorization gate (use isAdminEmail
  // only as a non-security display hint).
  try {
    // Claim a pending pre-approved grant (server checks the email is verified).
    await supabase.rpc("claim_pending_admin_grant");
    const { data: roleRow } = await supabase
      .from("user_roles")
      .select("role")
      .eq("user_id", session.user.id)
      .eq("role", "admin")
      .maybeSingle();

    return Boolean(roleRow);
  } catch {
    return false;
  }
}
